import { z } from 'zod';

export const OptionValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.date()
]);
export const OptionBlockSchema = z.object({
  option: z.string().trim(),
  value: OptionValueSchema
});

export type OptionBlock = z.infer<typeof OptionBlockSchema>;
